import { TFunction } from "i18next";

// Variant keys mirror pd-candidate-selection (SelectApplicationType/config/def.ts).
// Labels live in i18n `candidateType.<key>` so no separate entity is needed.
export const CANDIDATE_TYPE_KEYS = [
  "newDealer",
  "newReorganization",
  "oldReconstruction",
  "oldBuilding",
  "oldMoving",
  "oldAdditional",
] as const;

export type CandidateTypeKey = (typeof CANDIDATE_TYPE_KEYS)[number];

export const getCandidateTypeLabel = (
  t: TFunction,
  value: string | null | undefined,
): string => {
  if (!value) return "";
  return t(`candidateType.${value}`);
};

export const getCandidateTypeOptions = (t: TFunction) => [
  { value: "", label: "Не выбран" },
  ...CANDIDATE_TYPE_KEYS.map((key) => ({
    value: key,
    label: t(`candidateType.${key}`),
  })),
];
